/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';
import { ComuneCompactDTO } from './comune-compact-dto';


export interface OperatoreComuneDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    account_enabled?: boolean;
    account_activated?: boolean;
    invito_in_attesa?: boolean;
    authorities?: Set<AuthorityType>;
    comuni_gestiti?: Array<ComuneCompactDTO>;
}

